import React from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from "react-icons/io";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const getOrderFromOrTo = (item) => {
  if (item?.orderType.endsWith("to kryzen")) {
    return `From: ${item?.user_model?.userName}` || "N/A";
  }
  if (!item.orderTo) {
    return "To: NA";
  }
  if (item.orderTo === 1) {
    return "To: Kryzen";
  }
  if (item.orderTo === 2) {
    return "To: Kryzen CNF";
  } else {
    return `To: ${item?.OrderToUser?.userName}`;
  }
};
const getOrderFor = (item) => {
  if (item.productId) {
    return item?.pmg_plant?.agronomyWikiUpdate?.name;
  }
  if (item?.accId) {
    return item?.pmg_accessory?.name;
  }
  return "NA";
};
const getOrderStatus = (data) => {
  if (data?.status === "accepted") {
    return <span class="badge bg-green text-green-fg">ACCEPTED</span>;
  }
  return <span class="badge bg-red text-red-fg">PENDING</span>;
};
const KryzenOrderTable = ({ data, currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/kryzen-order/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            <th>Sr</th>
            <th>Order Id</th>
            <th></th>
            <th></th>
            <th className="d-none d-md-table-cell">From/To</th>
            <th>Order for</th>
            <th className="d-none d-md-table-cell">Quantity</th>
            <th className="d-none d-md-table-cell">Order Status</th>
            <th className="d-none d-md-table-cell">Actions</th>
            <th className="d-md-none d-sm-table-cell">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td className="d-none d-md-table-cell" colSpan={3}>
                  {item?.orderType?.endsWith("to kryzen") ? (
                    <IoIosArrowRoundDown
                      className="me-2 fs-2"
                      style={{ color: "green" }}
                    />
                  ) : (
                    <IoIosArrowRoundUp
                      className="me-2 fs-2"
                      style={{ color: "red" }}
                    />
                  )}
                  <b>{item?.orderID || "N/A"}</b>
                </td>
                <td className="d-none d-md-table-cell">
                  {getOrderFromOrTo(item)}
                </td>
                <td className="d-none d-md-table-cell">{getOrderFor(item)}</td>
                <td className="d-none d-md-table-cell">
                  {item?.quantity || "N/A"}
                </td>
                <td className="d-none d-md-table-cell">
                  {getOrderStatus(item)}
                </td>

                <td className="d-md-none d-sm-table-cell" colSpan={3}>
                  {item?.orderType?.endsWith("to kryzen") ? (
                    <IoIosArrowRoundDown
                      className="me-2 fs-2"
                      style={{ color: "green" }}
                    />
                  ) : (
                    <IoIosArrowRoundUp
                      className="me-2 fs-2"
                      style={{ color: "red" }}
                    />
                  )}
                  <b>{item?.orderID || "N/A"}</b>
                  <span> {getOrderStatus(item)}</span>
                </td>

                <td className="d-md-none d-sm-table-cell">
                  <span className="me-2">{item?.quantity || "N/A"}</span>
                  {getOrderFor(item)}
                  <p>{getOrderFromOrTo(item)}</p>
                </td>
                <td>
                  <CustomViewButton onClick={() => goToView(item?.id)}></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default KryzenOrderTable;
